export default __webpack_public_path__ + "static/media/LogoAJB.df9662dc.png";